/** Navegação global da SPA Ludi */
export const NAV_ITEMS = [
  { path: '/', label: 'Início', icon: 'home' },
  { path: '/workout', label: 'Sessão', icon: 'session' },
  { path: '/workouts-manage', label: 'Treinos', icon: 'workouts' },
  { path: '/plan', label: 'Plano IA', icon: 'plan' },
  { path: '/history', label: 'Histórico', icon: 'history' },
  { path: '/statistics', label: 'Stats', icon: 'statistics' },
  { path: '/profile', label: 'Perfil', icon: 'profile' },
];
